import { Badge, styled } from '@mui/material'

import { theme } from 'styles/theme'

export const Wrapper = styled('div')(() => ({
  alignItems: 'center',
  borderRadius: '50%',
  cursor: 'pointer',
  display: 'flex',
  height: '32px',
  justifyContent: 'center',
  position: 'relative',
  width: '32px'
}))

export const StyledBadge = styled(Badge)(() => ({
  '& .MuiBadge-badge': {
    backgroundColor: theme.palette.error[300],
    color: '#fff',
    fontSize: '10px',
    fontWeight: 700,
    minWidth: '18px',
    height: '18px',
    padding: '0 5px',
    right: -1,
    top: -1,
    border: `2px solid ${theme.palette.neutral.A200}`,
    borderRadius: '10px',
    letterSpacing: '-0.2px'
  }
}))
